var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StardogSparqlParser } from '../sparql';
// Returns a custom visitor that extends the BaseVisitor for the SRS parser.
// When the visitor encounters an SRS `IfClause` or an SRS `ThenClause`, it
// delegates parsing of the block to the existing SPARQL parser's relevant
// sub-rule (GroupGraphPattern or TriplesBlock).
export var getSparqlSrsVisitor = function (BaseVisitor) {
    var SparqlSrsVisitor = /** @class */ (function (_super) {
        __extends(SparqlSrsVisitor, _super);
        function SparqlSrsVisitor() {
            var _this = _super.call(this) || this;
            _this.groupGraphPatterns = [];
            _this.triplesBlocks = [];
            // Get and store the SPARQL `GroupGraphPattern` that should replace the
            // SRS placeholder `GroupGraphPattern` token inside of an SRS `IfClause`.
            _this.IfClause = function (ctx) {
                var GroupGraphPattern = ctx.GroupGraphPattern;
                _this.$storePlaceholderTokenReplacement({
                    tokenStore: _this.groupGraphPatterns,
                    originalTokenContext: GroupGraphPattern,
                    subParserRule: _this.sparqlParser.parseGroupGraphPattern.bind(_this.sparqlParser),
                });
            };
            // Get and store the SPARQL `TriplesBlock` that should replace the
            // SRS placeholder `TriplesBlock` token inside of an SRS `ThenClause`.
            _this.ThenClause = function (ctx) {
                var TriplesBlock = ctx.TriplesBlock;
                _this.$storePlaceholderTokenReplacement({
                    tokenStore: _this.triplesBlocks,
                    originalTokenContext: TriplesBlock,
                    subParserRule: _this.sparqlParser.parseTriplesBlock.bind(_this.sparqlParser),
                });
            };
            // Utility methods ('$' prefix is necessary to prevent chevrotain's
            // `validateVisitor` method from complaining that these are not grammar
            // rules):
            _this.$storePlaceholderTokenReplacement = function (_a) {
                var tokenStore = _a.tokenStore, _b = _a.originalTokenContext, originalTokenContext = _b === void 0 ? [] : _b, subParserRule = _a.subParserRule;
                var originalToken = originalTokenContext[0];
                if (!originalToken || typeof originalToken.image !== 'string') {
                    return;
                }
                var replacement = _this.$getPlaceholderTokenReplacement(originalToken, subParserRule);
                tokenStore.push({
                    parseResult: replacement,
                    originalToken: originalToken,
                });
            };
            _this.$getPlaceholderTokenReplacement = function (originalToken, subParserRule) {
                // Because we are replacing tokens by delegating the parsing of parts
                // of the original document to sub-parsers, we add some empty padding to
                // the part that is passed to the sub-parser, where the amount of padding
                // matches the start line and offset of the token we are replacing. This
                // ensures that all tokens have the right positions in the resulting CST
                // (otherwise, the sub-parsers assume that the text starts at offset 0).
                var image = originalToken.image, startOffset = originalToken.startOffset, startLine = originalToken.startLine, startColumn = originalToken.startColumn;
                var frontPadding = '';
                for (var line = 1; line < (startLine || 1); line++) {
                    frontPadding += '\n';
                }
                for (var column = 1; column < (startColumn || 1); column++) {
                    frontPadding += ' ';
                }
                if (frontPadding.length < startOffset) {
                    frontPadding = "" + ' '.repeat(startOffset - frontPadding.length) + frontPadding;
                }
                return subParserRule("" + frontPadding + image);
            };
            _this.$getGroupGraphPatterns = function () { return _this.groupGraphPatterns; };
            _this.$getTriplesBlocks = function () { return _this.triplesBlocks; };
            _this.$resetState = function () {
                _this.groupGraphPatterns = [];
                _this.triplesBlocks = [];
            };
            _this.sparqlParser = new StardogSparqlParser();
            _this.validateVisitor();
            return _this;
        }
        return SparqlSrsVisitor;
    }(BaseVisitor));
    return new SparqlSrsVisitor();
};
export function reduceVisitorItemErrors(acc, item) {
    return acc.concat(item.parseResult.errors);
}
// The SRS cst contains placeholder tokens for unparsed blocks of SPARQL
// inside of an SRS `IfClause` or `ThenClause`. This method swaps out those
// placeholders with the actual SPARQL CST created by the SparqlSrsVisitor.
export function findAndSwapPlaceholders(node, parentNode, visitorItems, key) {
    var matchingVisitorItem = visitorItems.find(function (visitorItem) { return visitorItem.originalToken === node; });
    if (matchingVisitorItem) {
        parentNode.children[key] = [matchingVisitorItem.parseResult.cst];
    }
    return matchingVisitorItem;
}
